import { render, staticRenderFns } from "./TwitterIcon.vue?vue&type=template&id=b413a3ec&scoped=true"
import script from "./TwitterIcon.vue?vue&type=script&lang=ts"
export * from "./TwitterIcon.vue?vue&type=script&lang=ts"
import style0 from "./TwitterIcon.vue?vue&type=style&index=0&id=b413a3ec&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b413a3ec",
  null
  
)

export default component.exports